module.exports = __webpack_public_path__ + "static/media/rfet5.b8574ef1.png";